module.exports = __webpack_public_path__ + "static/media/nasa_poster_2.afbb5289.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/detail/nasa_poster_2.png
// module id = 564
// module chunks = 0